import { Bell, BellOff, BellRing, MonitorDot } from 'lucide-react';
import { motion } from 'motion/react';

export default function ServiceHeader({ stats, muted, onToggleMuted, socketState, view, onViewChange }) {
  const openRequests = stats?.openRequests || 0;

  return (
    <header className="service-header">
      <div>
        <p className="service-kicker">Servicio en vivo</p>
        <h1>Panel de comandas</h1>
        <div className="service-status-row">
          <span className={`service-socket service-socket-${socketState}`}>
            <MonitorDot size={15} />
            {socketState === 'connected' ? 'Tiempo real conectado' : 'Reconectando'}
          </span>
          <span>{stats.openTables} mesas abiertas</span>
          <span>{stats.liveOrders} comandas activas</span>
        </div>
      </div>

      <div className="service-header-actions">
        {openRequests > 0 && (
          <motion.div
            className="service-request-counter"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', damping: 18, stiffness: 320 }}
          >
            <motion.span
              animate={{ rotate: [0, -10, 10, -8, 8, 0] }}
              transition={{ duration: 1.6, repeat: Infinity, repeatDelay: 2 }}
            >
              <BellRing size={15} />
            </motion.span>
            <strong>{openRequests}</strong>
            <span>{openRequests === 1 ? 'solicitud' : 'solicitudes'}</span>
          </motion.div>
        )}
        <div className={`service-urgent-counter ${stats.urgentOrders > 0 ? 'is-hot' : ''}`}>
          <strong>{stats.urgentOrders}</strong>
          <span>urgentes</span>
        </div>
        <button className="service-icon-button" type="button" onClick={onToggleMuted} title={muted ? 'Activar sonido' : 'Silenciar sonido'}>
          {muted ? <BellOff size={18} /> : <Bell size={18} />}
        </button>
        <div className="service-view-tabs" role="tablist" aria-label="Vista de servicio">
          <button className={view === 'plano' ? 'is-active' : ''} onClick={() => onViewChange('plano')} type="button">Plano</button>
          <button className={view === 'orders' ? 'is-active' : ''} onClick={() => onViewChange('orders')} type="button">Comandas</button>
        </div>
      </div>
    </header>
  );
}
